var exports = {
  "nd": "CompanionPanel.module__panel___cExGRk",
  "wx": "CompanionPanel.module__header___cExGRk",
  "$s": "CompanionPanel.module__headerActions___cExGRk",
  "y2": "CompanionPanel.module__preferencesSection___cExGRk",
  "mK": "CompanionPanel.module__preferencesActions___cExGRk",
  "TK": "CompanionPanel.module__headerText___cExGRk",
  "sy": "CompanionPanel.module__titleRow___cExGRk",
  "DD": "CompanionPanel.module__title___cExGRk",
  "W5": "CompanionPanel.module__statusArea___cExGRk",
  "qs": "CompanionPanel.module__textComposer___cExGRk",
  "aW": "CompanionPanel.module__statusBar___cExGRk",
  "XI": "CompanionPanel.module__statusCaption___cExGRk",
  "Od": "CompanionPanel.module__statusBadge___cExGRk",
  "F0": "CompanionPanel.module__statusIdle___cExGRk",
  "Io": "CompanionPanel.module__statusBusy___cExGRk",
  "xk": "CompanionPanel.module__statusActive___cExGRk",
  "hU": "CompanionPanel.module__statusWarning___cExGRk",
  "gJ": "CompanionPanel.module__errorMessage___cExGRk",
  "VN": "CompanionPanel.module__aiReplyChip___cExGRk",
  "zr": "CompanionPanel.module__summaryCard___cExGRk",
  "Ov": "CompanionPanel.module__summaryHeader___cExGRk",
  "hZ": "CompanionPanel.module__summaryTitle___cExGRk",
  "g5": "CompanionPanel.module__summaryText___cExGRk",
  "Qs": "CompanionPanel.module__content___cExGRk",
  "uW": "CompanionPanel.module__section___cExGRk",
  "se": "CompanionPanel.module__transcriptSection___cExGRk",
  "bV": "CompanionPanel.module__sectionHeader___cExGRk",
  "Gf": "CompanionPanel.module__sectionTitle___cExGRk",
  "j5": "CompanionPanel.module__transcriptScroller___cExGRk",
  "p$": "CompanionPanel.module__emptyState___cExGRk",
  "cd": "CompanionPanel.module__emptyStateCompact___cExGRk",
  "xJ": "CompanionPanel.module__transcriptList___cExGRk",
  "qg": "CompanionPanel.module__transcriptItem___cExGRk",
  "j9": "CompanionPanel.module__transcriptItemPartial___cExGRk",
  "KW": "CompanionPanel.module__transcriptText___cExGRk",
  "I4": "CompanionPanel.module__transcriptMeta___cExGRk",
  "wJ": "CompanionPanel.module__speakerLabel___cExGRk",
  "zo": "CompanionPanel.module__speakerId___cExGRk",
  "ZI": "CompanionPanel.module__quickActionsRow___cExGRk",
  "Ck": "CompanionPanel.module__askComposer___cExGRk",
  "xw": "CompanionPanel.module__suggestionList___cExGRk",
  "$": "CompanionPanel.module__suggestionCard___cExGRk",
  "AF": "CompanionPanel.module__suggestionHeaderRow___cExGRk",
  "DE": "CompanionPanel.module__suggestionKind___cExGRk",
  "mx": "CompanionPanel.module__suggestionStreamingBadge___cExGRk",
  "_T": "CompanionPanel.module__suggestionText___cExGRk",
  "Ah": "CompanionPanel.module__suggestionActions___cExGRk",
  "sw": "CompanionPanel.module__copiedFeedback___cExGRk",
  "r": "CompanionPanel.module__dismissButton___cExGRk",
  "c8": "CompanionPanel.module__speakerList___cExGRk",
  "B4": "CompanionPanel.module__speakerItem___cExGRk",
  "kz": "CompanionPanel.module__speakerDetails___cExGRk",
  "$P": "CompanionPanel.module__speakerName___cExGRk",
  "om": "CompanionPanel.module__speakerRole___cExGRk",
  "Fc": "CompanionPanel.module__speakerActions___cExGRk",
  "Ch": "CompanionPanel.module__sceneHint___cExGRk",
  "qr": "CompanionPanel.module__footer___cExGRk",
  "Yb": "CompanionPanel.module__footerSingleAction___cExGRk",
  "wC": "CompanionPanel.module__footerButton___cExGRk",
  "Uy": "CompanionPanel.module__spinningIcon___cExGRk",
  "Ju": "CompanionPanel.module__companion-panel-spin___cExGRk",
  "sQ": "CompanionPanel.module__setupBody___cExGRk",
  "BR": "CompanionPanel.module__sessionBody___cExGRk",
  "rJ": "CompanionPanel.module__sourceArea___cExGRk",
  "xH": "CompanionPanel.module__modeSelectArea___cExGRk",
  "f9": "CompanionPanel.module__modeCards___cExGRk",
  "OW": "CompanionPanel.module__modeCard___cExGRk",
  "rh": "CompanionPanel.module__modeCardIcon___cExGRk",
  "X6": "CompanionPanel.module__modeCardText___cExGRk",
  "Iu": "CompanionPanel.module__modeCardTitle___cExGRk",
  "pA": "CompanionPanel.module__modeCardDesc___cExGRk",
  "Bn": "CompanionPanel.module__setupModeRow___cExGRk",
  "Z6": "CompanionPanel.module__setupModeLabel___cExGRk",
  "dH": "CompanionPanel.module__audioControls___cExGRk",
  "bd": "CompanionPanel.module__inputRow___cExGRk",
  "kP": "CompanionPanel.module__inputMeter___cExGRk",
  "Bb": "CompanionPanel.module__sceneLabel___cExGRk",
};

module.exports = exports;
